import { __OBJECT_STRUCTURE_GetList } from "../common/ObjectStructures/Trasnversal";
import { 
	SET_GAP_ACTIONS_LIST,
	SET_GAP_CAUSE_LIST,
	SET_GAP_SELECTED_ACTION_TO_DIALOG
} from "./actions/KPI/actions";

const initialState = {
	_actions: __OBJECT_STRUCTURE_GetList(10),
	_selectedActionToDialog: null
};

const gapReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_GAP_ACTIONS_LIST:
			return {
				...state,
				_actions: action.payload
			};
		case SET_GAP_SELECTED_ACTION_TO_DIALOG:
			return {
				...state,
				_selectedActionToDialog: action.payload
			};

		case SET_GAP_CAUSE_LIST:
			return {
				...state,
				_causes: action.payload
			};
			
		default:
			return state;
	}
};

export default gapReducer;